import { HttpEvent, HttpHandler, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { TokenSyncService } from '@stylehaven/components';
import { EMPTY, Observable, Subject } from 'rxjs';
import { catchError, switchMap, tap } from 'rxjs/operators';
import { AuthenticationService } from '../../services/authentication/authentication.service';
import { TokenRefreshStrategy } from './index';

@Injectable()
export class RefreshRefreshTokenStrategy implements TokenRefreshStrategy {
    constructor(
        private readonly authService: AuthenticationService,
        private readonly tokenSyncService: TokenSyncService
    ) {}

    refreshToken(
        req: HttpRequest<any>,
        next: HttpHandler,
        callBackSubject: Subject<string | undefined>
    ): Observable<HttpEvent<any>> {
        const refreshToken = this.tokenSyncService.tokens?.refresh_token;
        if (!refreshToken) {
            return this.handleRefreshTokenError();
        }

        return this.authService.refreshToken(refreshToken).pipe(
            catchError(this.handleRefreshTokenError.bind(this)),
            tap(tokens => callBackSubject.next(tokens.refresh_token)),
            switchMap(() => next.handle(req))
        );
    }

    private handleRefreshTokenError(): Observable<never> {
        this.authService.logout();
        return EMPTY;
    }
}
